import axios from "axios";

const REACT_APP_API_URL = process.env.REACT_APP_API_URL

export const fetchNews = async () => {
    const res = await axios.get(`${REACT_APP_API_URL}/articles`)
    if (res.status !== 200) {
        return []
    }
    return res.data
}

export const fetchNewsBySlug = async (slug) => {
    const res = await axios.get(`${REACT_APP_API_URL}/articles/${slug}`)
    if (res.status !== 200) {
        return null
    }
    return res.data
}